import React from 'react';
import ImageGalleryilmfoundation from '../components/ImageGalleryilmfoundation';
// import IRCTVDonationCard from "./IRCTVDonationCard";

const IRCDAWAH = () => {
      const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };
  
  const handleBookDonationClick = () => {
    // You can add functionality here, such as:
    // 1. Open a modal/form for book donation
    // 2. Navigate to a book donation page
    // 3. Show contact information
    // 4. Open email client
    alert('Thank you for wanting to donate books! Please contact us at 7537-9999-44 to arrange book donation.');
    
    // Alternative: Open email
    // window.location.href = 'mailto:contact@irc.org?subject=Book Donation&body=I would like to donate books to the Free Book Bank.';
  };
  
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGalleryilmfoundation />

                    {/* IRC 10 Days WEEKLY */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>FREE BOOK BANK</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                Our Free Book Bank is a community initiative where students can donate their used textbooks and academic books so that other students can take them free of cost. The goal is simple: no student should struggle in their studies due to lack of books.
                                By sharing resources, we reduce waste, support education, and build a culture of helping one another grow. Donate a book, take a book — and pass knowledge forward.

                            </p>
                            <div className="clinic-card" style={{ position: 'relative', padding: '20px' }}>
                                <p><strong>Name:</strong> FREE BOOK BANK</p>
                                <p><strong>Date of Inauguration:</strong> NA</p>
                                <p>
                                    <strong>Contact No: </strong>
                                    <span
                                        className="contact-number"
                                        onClick={() => handlePhoneClick('7537-9999-44')}
                                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                    >
                                        7537-9999-44
                                    </span>
                                </p>
                                <p><strong>Address:</strong> 1-23-94 Rohila Gali Aurangabad – 431001</p>
                                  <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/Masjid+Ikhlas/@19.8910191,75.3309355,108m/data=!3m1!1e3!4m6!3m5!1s0x3bdb99588c76a00f:0xcf1c49b4ae78975!8m2!3d19.8909467!4d75.330867!16s%2Fg%2F11vjm4_dll?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                
                                {/* Donate Your Books Button */}
                                <button
                                    onClick={handleBookDonationClick}
                                    style={{
                                        position: 'absolute',
                                        right: '80px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        padding: '15px 25px',
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#218838';
                                        e.target.style.transform = 'translateY(-50%) scale(1.05)';
                                        e.target.style.boxShadow = '0 6px 16px rgba(40, 167, 69, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#28a745';
                                        e.target.style.transform = 'translateY(-50%)';
                                        e.target.style.boxShadow = '0 4px 12px rgba(40, 167, 69, 0.3)';
                                    }}
                                >
                                    📚 Donate Your Books
                                </button>
                            </div>
                        </div>
                        {/* <IRCTVDonationCard
                            title="FREE BOOK BANK"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: FREE BOOK BANK"
                        /> */}
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCDAWAH;